module.exports = __webpack_public_path__ + "static/media/meso.15f2c92c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/injectionMoulds/meso.jpg
// module id = 208
// module chunks = 0